const errRequired = (field: string) => `${field} is required`;

const errFormat = (field: string) => `${field} is invalid`;

const errFormatNumeric = (field: string) => `${field} must be numeric`;

const errMin = (field: string, valueLen?: number, min?: number) => {
    if (valueLen === 0 || !valueLen) {
        return errRequired(field);
    }
    if (valueLen > 0 && min && valueLen < min) {
        return `${field} must be at least ${min} characters`;
    }
    return '';
};

const errMax = (field: string, valueLen: number, max: number) =>
    `${field} cannot exceed ${max} characters. Now: ${valueLen}`;

const errNumMin = (field: string, min: number) => `${field} must not be less than ${min}`;

const errNumMax = (field: string, max: number) => `${field} must not be more than ${max}`;

const errArrayMin = (field: string, min: number) =>
    `${field} must choose at least ${min} ${min > 1 ? 'options' : 'option'}`;
const errArrayMinFiles = (field: string, min: number) =>
    `${field} must upload at least ${min} ${min > 1 ? 'files' : 'file'}`;
const errArrayMaxFiles = (field: string, max: number) =>
    `${field} must upload at most ${max} ${max > 1 ? 'files' : 'file'}`;
const errArrayMax = (field: string, max: number) =>
    `${field} must choose at most ${max} ${max > 1 ? 'options' : 'option'}`;

const FormUtil = {
    msg: {
        PASSWORD_UNMATCH: 'Passwords do not match',
        errRequired,
        errMin,
        errMax,
        errNumMin,
        errNumMax,
        errArrayMin,
        errArrayMinFiles,
        errArrayMaxFiles,
        errArrayMax,
        errFormat,
        errFormatNumeric,
    },
    regexHelper: {
        isDigitsOnly: (value: any) => /^\d*$/.test(value),
    },
};

export default FormUtil;
